export default [

  {
    path: '/gplans/garden',
    name: 'gplans.garden.index',
    component: () => import('@/new/pages/gplan/GardenGPlan.vue'),
    meta: {
      module: 'gplans.garden',
      pageTitle: 'Garden Plans',
      breadcrumb: [
        { text: 'Geofence Garden Plans', active: true, },
      ],
    }
  },

]
